/* -------------------------------------------------------------------------- */
/*                               Schema Assets                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const asset = new schema.Entity('assets', {}, { idAttribute: 'assetId' });
export const assets = new schema.Array(asset);
